import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Credentials } from 'shared/models';
import { CredentialsLine } from './credentialsLine';

require('./credentialsList.css');

export type Props = {
    credentials: Credentials[];
    onChangeCredentials: (provider: string) => (credentials: Credentials) => void;
    onClickDelete: (provider: string) => () => void;
};

const emptyArray: Credentials[] = [];

export const CredentialsList = ({ credentials = emptyArray, onChangeCredentials, onClickDelete }: Props) => {
    const { t } = useTranslation();
    return (
        <table style={ { width: '100%', maxWidth: '800px', marginBottom: '1em' } } className="credentials-list ui single line compact table form">
            <colgroup>
                <col style={ { width: '25%' } }/>
                <col style={ { width: '20%' } }/>
                <col style={ { width: '30%' } }/>
                <col style={ { width: '25%' } }/>
                <col style={ { width: '32px' } }/>
            </colgroup>
            <thead>
                <tr>
                    <th>{ t('BUILDING.CREDENTIALS.COLUMN.PROVIDER') }</th>
                    <th>{ t('BUILDING.CREDENTIALS.COLUMN.APPID') }</th>
                    <th>{ t('BUILDING.CREDENTIALS.COLUMN.USERNAME') }</th>
                    <th>{ t('BUILDING.CREDENTIALS.COLUMN.PASSWORD') }</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                { !credentials.length &&
                    <tr>
                        <td colSpan={ 5 } style={ { opacity: .6 } }>
                            { t('BUILDING.CREDENTIALS.NONE') }
                        </td>
                    </tr>
                }
                { credentials.length > 0 && credentials.filter(c => !!c).map(c =>
                    <CredentialsLine
                        key={ c.provider }
                        credentials={ c }
                        onChangeCredentials={ onChangeCredentials(c.provider) }
                        onClickDelete={ onClickDelete(c.provider) }
                    />
                )}
            </tbody>
        </table>
    );
};
